export default __webpack_public_path__ + "static/media/vitra_chair_01.709c0d43.png";